export default function (data) {
   return data.map(function (i) {
      return {
         label: i.name,
         value: i.id
      };
   });
}



/** WEBPACK FOOTER **
 ** ./src/selectors/selectOptionFormatter.js
 **/